import React from 'react';
import styled from 'styled-components';
import { bool } from 'prop-types';
import { colors, breakpoints } from '../../styles';

const ComingSoonContainer = styled.span`
  background: ${({ disabled }) => (disabled ? colors.grey : colors.black)};
  color: ${({ disabled }) => (disabled ? colors.lighterGrey : colors.yellow)};
  font-size: 0.7rem;
  font-weight: bold;
  border-radius: 15px;
  text-transform: uppercase;
  padding: 5px 10px;
  white-space: nowrap;

  @media only screen and (max-width: ${breakpoints.largeMonitor}) {
    font-size: 0.6rem;
  }

  @media only screen and (max-width: ${breakpoints.mobile}) {
    font-size: 0.4rem;
  }
`;

const ComingSoon = ({ disabled }) => (
  <ComingSoonContainer disabled={disabled} data-testid="coming-soon">
    Coming Soon
  </ComingSoonContainer>
);

ComingSoon.propTypes = {
  disabled: bool
};

export default ComingSoon;
